import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateCondition } from '../../../state';
import { useGetConditionOperatorsQuery } from '../../../../../services/WorkflowService';
import { useWorkflowValidationContext, getConditionError } from '../../shared';

interface ConditionOperatorSelectProps {
  index: number;
}

export const ConditionOperatorSelect: React.FC<ConditionOperatorSelectProps> = ({ index }) => {
  const dispatch = useAppDispatch();
  const condition = useAppSelector((state) => state.workflow.currentWorkflow?.conditions[index]);
  const { data: conditionOperators = [], isLoading: loadingOperators } = useGetConditionOperatorsQuery();
  const { errors, showErrors } = useWorkflowValidationContext();

  if (!condition) return null;

  const isValidOperator = conditionOperators.some(op => op.value === condition.operator);
  const selectValue = isValidOperator || loadingOperators ? condition.operator : '';
  const operatorErr = getConditionError(errors, showErrors, index, 'operator');

  return (
    <FormControl size="small" sx={{ minWidth: 150 }} error={!!operatorErr}>
      <InputLabel>Operator</InputLabel>
      <Select
        value={selectValue}
        label="Operator"
        onChange={(e) => dispatch(updateCondition({ index, field: 'operator', value: e.target.value }))}
        disabled={loadingOperators}
      >
        {conditionOperators.map((op) => (
          <MenuItem key={op.value} value={op.value}>
            {op.name}
          </MenuItem>
        ))}
      </Select>
      {operatorErr && <FormHelperText>{operatorErr}</FormHelperText>}
    </FormControl>
  );
};

export default ConditionOperatorSelect;
